// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "50cb5ef00652b2d5d9c0" + "/js/" + chunkId + ".js";
};